/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import s from './ToiplusFooter.scss';

function ToiplusFooter(props) {
  const { footerData, userData } = props;
  const { isLoggedIn = undefined } = userData;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
  // Need to change gaFaq
  const gaFaq = type => {
    analyticsWrapper(
      'ga',
      'send',
      'event',
      window.categoryForGA,
      `TOIPlus_PlanPage_Click_${type}`,
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
    );
  };
  return (
    <div className={s.toiplusFooter} id="toipfooter">
      <ul className={s.footerNav}>
        <li>
          <a
            href={footerData?.faqData?.link}
            onClick={() => {
              gaFaq('faq');
            }}
          >
            {footerData?.faqData?.txt}
          </a>
        </li>
        <li>
          <a
            href={footerData?.tncData?.link}
            onClick={() => {
              gaFaq('T&C');
            }}
          >
            {footerData?.tncData?.txt}
          </a>
        </li>
        <li>
          <a
            href={footerData?.ppData?.link}
            onClick={() => {
              gaFaq('privacy_policy');
            }}
          >
            {footerData?.ppData?.txt}
          </a>
        </li>
      </ul>
      {footerData?.copyrightData && (
        <p
          dangerouslySetInnerHTML={{ __html: `${footerData?.copyrightData}` }}
        />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  userData: _get(state, 'login.userData', {}),
});

ToiplusFooter.propTypes = {
  footerData: PropTypes.shape({
    faqData: PropTypes.shape({}),
    ppData: PropTypes.shape({}),
    tncData: PropTypes.shape({}),
    copyrightData: PropTypes.string,
  }).isRequired,
  userData: PropTypes.shape({}).isRequired,
};

export default connect(mapStateToProps)(ToiplusFooter);
